// extracted by mini-css-extract-plugin
export default {"contentWrapper":"App_contentWrapper__p2cwb"};